/* REACT IMPORTS */
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

/* PACKAGES */
import { AnimatePresence } from "framer-motion";

/* STYLES */
import "../styles/global.css";

/* LAYOUT */
import Layout from "../layout";

/* AUTHETICATION PAGES */
import LoginPage from "../pages/login";
import RegisterPage from "../pages/register";

/* HOMEPAGE */
import ComingSoon from "../pages/coming-soon";

/* PAGES */
import Checkout from "../pages/checkout";
import MyBag from "../pages/my-bag";
import Dashboard from "../pages/dashboard";
import ProductDetail from "../pages/product-detail";
import Shop from "../pages/shop";
import CancellationPolicy from "../pages/cancellation-policy";
import ReturnPolicy from "../pages/return-policy";
import PrivacyPolicy from "../pages/privacy-policy";
import TermsConditions from "../pages/terms-and-conditions";
import ContactUs from "../pages/contact-us";
import PressMedia from "../pages/press-media";
import BlogDetails from "../pages/blog-details";
import NotFound from "../pages/not-found";
import Wishlist from "../pages/wishlist";

/* SCROLL TO TOP */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <AnimatePresence>
      <div className="app">
        <Router>
          <ScrollToTop />
          <Layout>
            <Routes>
              {/* AUTHETICATION PAGES */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              {/* HOMEPAGE */}
              <Route path="/" element={<ComingSoon />} />

              {/* CHECKOUT PAGE */}
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/my-bag" element={<MyBag />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/product-detail" element={<ProductDetail />} />
              <Route path="/shop" element={<Shop />} />
              <Route
                path="/cancellation-policy"
                element={<CancellationPolicy />}
              />
              <Route path="/return-policy" element={<ReturnPolicy />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/press-and-media" element={<PressMedia />} />
              <Route path="/blog-details" element={<BlogDetails />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </Router>
      </div>
    </AnimatePresence>
  );
};

export default AppRoutes;
